/* UniqParty FX — confetti/stars on scroll, floating balloons, add-to-cart burst.
   Self-contained, no dependencies. Respects prefers-reduced-motion. */
(function () {
  "use strict";
  try {
    if (window.__uniqFX) return;
    window.__uniqFX = true;

    var mq = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)");
    if (mq && mq.matches) return;
    if (window.Shopify && window.Shopify.designMode) return; // don't distract in the theme editor

    var COLORS = ["#FF6A2C", "#FFC21E", "#FF4E8A", "#2CC7C4", "#7B4FD0", "#F5402C", "#F3E9D8"];
    var TAU = Math.PI * 2;
    function rnd(a, b) { return a + Math.random() * (b - a); }
    function pick(a) { return a[(Math.random() * a.length) | 0]; }

    /* ---------- styles ---------- */
    var style = document.createElement("style");
    style.textContent =
      ".uqfx-canvas{position:fixed;inset:0;width:100%;height:100%;pointer-events:none;z-index:2147483600}" +
      ".uqfx-balloons{position:fixed;inset:0;overflow:hidden;pointer-events:none;z-index:2147483500}" +
      ".uqfx-balloon{position:absolute;bottom:-170px;will-change:transform,opacity;animation:uqfx-rise var(--d,13s) linear forwards}" +
      "@keyframes uqfx-rise{0%{transform:translate3d(0,0,0) rotate(0);opacity:0}" +
      "10%{opacity:.92}82%{opacity:.92}100%{transform:translate3d(var(--x,0),calc(-100vh - 240px),0) rotate(var(--r,6deg));opacity:0}}";
    document.head.appendChild(style);

    /* ---------- confetti canvas ---------- */
    var canvas = document.createElement("canvas");
    canvas.className = "uqfx-canvas";
    canvas.setAttribute("aria-hidden", "true");
    document.body.appendChild(canvas);
    var ctx = canvas.getContext("2d");
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    function resize() {
      canvas.width = innerWidth * dpr;
      canvas.height = innerHeight * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    resize();
    addEventListener("resize", resize);

    var parts = [], raf = 0, MAX = 240;
    function addPart(x, y, vx, vy, shape, color, size) {
      if (parts.length > MAX) return;
      parts.push({ x: x, y: y, vx: vx, vy: vy, rot: rnd(0, TAU), vr: rnd(-0.25, 0.25),
        shape: shape, color: color, size: size, life: 0, ttl: rnd(95, 155), wob: rnd(0, TAU), amp: rnd(0.4, 1.6) });
    }
    function starPath(c, r) {
      c.beginPath();
      for (var i = 0; i < 5; i++) {
        var a = -Math.PI / 2 + i * TAU / 5;
        c.lineTo(Math.cos(a) * r, Math.sin(a) * r);
        var a2 = a + TAU / 10;
        c.lineTo(Math.cos(a2) * r * 0.45, Math.sin(a2) * r * 0.45);
      }
      c.closePath();
    }
    function tick() {
      raf = 0;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (var i = parts.length - 1; i >= 0; i--) {
        var p = parts[i];
        p.life++;
        p.vy += 0.16;
        p.vx *= 0.992; p.vy *= 0.992;
        p.wob += 0.1;
        p.x += p.vx + Math.cos(p.wob) * p.amp;
        p.y += p.vy;
        p.rot += p.vr;
        if (p.life >= p.ttl || p.y > innerHeight + 70) { parts.splice(i, 1); continue; }
        var alpha = p.life > p.ttl * 0.7 ? Math.max(0, 1 - (p.life - p.ttl * 0.7) / (p.ttl * 0.3)) : 1;
        ctx.save();
        ctx.globalAlpha = alpha;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        if (p.shape === 0) { starPath(ctx, p.size); ctx.fill(); }
        else if (p.shape === 1) { ctx.fillRect(-p.size * 0.6, -p.size * 0.35, p.size * 1.2, p.size * 0.7); }
        else { ctx.beginPath(); ctx.arc(0, 0, p.size * 0.55, 0, TAU); ctx.fill(); }
        ctx.restore();
      }
      if (parts.length) raf = requestAnimationFrame(tick);
    }
    function run() { if (!raf) raf = requestAnimationFrame(tick); }
    function burst(x, y, count, power, dir) {
      dir = dir == null ? -Math.PI / 2 : dir;
      for (var i = 0; i < count; i++) {
        var ang = dir + rnd(-0.9, 0.9);
        var sp = rnd(power * 0.4, power);
        var shape = Math.random() < 0.5 ? 0 : (Math.random() < 0.5 ? 1 : 2);
        addPart(x, y, Math.cos(ang) * sp, Math.sin(ang) * sp, shape, pick(COLORS), rnd(5, 11));
      }
      run();
    }

    /* ---------- click: fire confetti cannons from the bottom corners ---------- */
    function fireCannons(big) {
      var n = big ? 22 : 13, p = big ? 20 : 16;
      burst(rnd(16, 54), innerHeight - 6, n, p, -Math.PI / 2.5);
      burst(innerWidth - rnd(16, 54), innerHeight - 6, n, p, -Math.PI / 1.53);
    }
    var lastClick = 0;
    document.addEventListener("click", function (e) {
      var addBtn = e.target && e.target.closest &&
        e.target.closest('button[name="add"], .product-form__submit, .quick-add__submit, [data-add-to-cart]');
      var now = (window.performance && performance.now) ? performance.now() : +new Date();
      if (!addBtn && now - lastClick < 280) return; // gentle throttle for rapid clicks
      lastClick = now;
      fireCannons(!!addBtn); // add-to-cart gets a bigger volley
    }, true);

    /* ---------- floating balloons ---------- */
    var bwrap = document.createElement("div");
    bwrap.className = "uqfx-balloons";
    bwrap.setAttribute("aria-hidden", "true");
    document.body.appendChild(bwrap);
    function balloonSVG(color) {
      return '<svg width="46" height="64" viewBox="0 0 46 64" xmlns="http://www.w3.org/2000/svg">' +
        '<ellipse cx="23" cy="22" rx="20" ry="24" fill="' + color + '"/>' +
        '<path d="M23 46 l-3 5 h6 z" fill="' + color + '"/>' +
        '<path d="M23 51 q6 10 0 13" stroke="rgba(60,60,60,.45)" stroke-width="1.4" fill="none"/>' +
        '<ellipse cx="16" cy="14" rx="5" ry="7" fill="rgba(255,255,255,.35)"/></svg>';
    }
    var balloonCount = 0, MAXB = innerWidth < 600 ? 2 : 3;
    function spawnBalloon() {
      if (document.hidden || balloonCount >= MAXB) return;
      var b = document.createElement("div");
      b.className = "uqfx-balloon";
      b.style.left = (Math.random() < 0.5 ? rnd(2, 22) : rnd(78, 97)) + "vw";
      b.style.setProperty("--d", rnd(11, 16) + "s");
      b.style.setProperty("--x", rnd(-40, 40) + "px");
      b.style.setProperty("--r", rnd(-10, 10) + "deg");
      b.style.transform = "scale(" + rnd(0.7, 1.15) + ")";
      b.innerHTML = balloonSVG(pick(COLORS));
      bwrap.appendChild(b);
      balloonCount++;
      b.addEventListener("animationend", function () { b.remove(); balloonCount--; });
    }
    function scheduleBalloon() {
      setTimeout(function () { spawnBalloon(); scheduleBalloon(); }, rnd(5000, 9000));
    }

    /* ---------- kickoff ---------- */
    function start() {
      scheduleBalloon(); // confetti is now click-triggered; balloons drift on their own
    }
    if (document.readyState === "complete" || document.readyState === "interactive") start();
    else addEventListener("DOMContentLoaded", start);
  } catch (err) { /* fail silent — never break the storefront */ }
})();
